import { Provider } from "react-redux";
import { Routes } from "./routes";
import { Amplify, Auth, Hub } from "aws-amplify";
import { PersistGate } from "redux-persist/integration/react";
import { persister, store } from "./state/store";
import { Path, Storage } from "./env";
import { useEffect } from "react";
import { GetShopSummary } from "./client/core";

Amplify.configure({
    Auth: {
        identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
        region: process.env.REACT_APP_COGNITO_REGION,
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN,
            redirectSignIn: window.location.protocol + "//" + window.location.host + Path.Login,
            redirectSignOut: window.location.protocol + "//" + window.location.host + Path.Login,
            responseType: 'code',
            scope: ['email', 'profile', 'openid']
        }
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_S3_IMAGE_UPLOAD_BUCKET_NAME,
            region: process.env.REACT_APP_S3_REGION,
        }
    },
});

function App() {
    useEffect(() => {
        const unsubscribe = Hub.listen('auth', ({ payload: { event, data } }) => {
            switch (event) {
                case 'signIn':
                    getShopId()
                    console.log('User signed in');
                    break;
                case 'signOut':
                    localStorage.removeItem(Storage.IsLoggedIn)
                    localStorage.removeItem(Storage.ShopAddressID)
                    localStorage.removeItem(Storage.ShopID)
                    localStorage.removeItem(Storage.ShopName)
                    console.log('User signed out');
                    // Redirect to login or handle sign out
                    break;
                case 'tokenRefresh':
                    break;
                case 'tokenRefresh_failure':
                    localStorage.removeItem(Storage.IsLoggedIn)
                    localStorage.removeItem(Storage.ShopAddressID)
                    localStorage.removeItem(Storage.ShopID)
                    localStorage.removeItem(Storage.ShopName)
                    console.log('Token refresh failed');
                    // Force user to sign in again
                    Auth.signOut();
                    break;
            }
        });

        return unsubscribe;
    }, []);

    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persister}>
                <div className="App" style={{ height: "100vh" }}>
                    <Routes />
                </div>
            </PersistGate>
        </Provider>
    );
}

const getShopId = async () => {
    try {
        if (localStorage.getItem(Storage.ShopID)) {
            return
        }

        Auth.currentSession().then(async (session) => {
            const token = session.getIdToken().getJwtToken();
            await new GetShopSummary()
                .GetShopID({
                    identityToken: token,
                })
                .then((output) => {
                    localStorage.setItem(Storage.ShopID, output.shopID!);
                })
                .catch((err) =>
                    console.log(err)
                );
        })
    } catch {

    }
}

export default App;